export default function RoundedPurpleContainer({ number, label, onClick }) {
  return (
    <div
      className="rounded-4 background-main-purple w-100"
      style={{
        maxWidth: "12rem",
        padding: ".6rem 1rem",
        cursor: onClick ? "pointer" : "default",
        textAlign: "center",
        border: "1px solid rgba(185, 151, 255, 0.12)",
      }}
      onClick={onClick}
    >
      <div>
        <span className="fw-bold" style={{ fontSize: "1.4rem" }}>
          {number}
        </span>
      </div>
      <div>
        <span
          className="fw-bold"
          style={{ fontSize: "0.8rem", color: "var(--main-purple)", letterSpacing: "0.03em" }}
        >
          {label}
        </span>
      </div>
    </div>
  );
}
